export default {
  props: {
    required: {
      type: Boolean
    },
    label: {
      type: String
    }
  },
  methods: {
    requiredLabel(label) {
      return (this.required ? "*" : "") + label;
    }
  }
};
